import BlujayBcaMasterLocationIndex from "@/components/blujay_bca/master_location/BlujayBcaMasterLocationIndex.vue";

let routesBlujayBcaMasterLocation = [
    {
        path: '',
        meta: {
            title: "Blujay Bca Master Location",
        },
        name: "BlujayBcaMasterLocationIndex",
        component: BlujayBcaMasterLocationIndex
    },
     
   
      
]

export default routesBlujayBcaMasterLocation
  